<div class="component">

  <div class="alignleft content mat-elevation-z8">
    <mat-form-field style=" margin: 10px; width: 50%;">
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter " id="input_filter">
    </mat-form-field>
    <div class="buttonGroup floatRight">
      <button mat-raised-button color="primary" (click)="getData()">Reload</button>
    </div>
  </div>
  <table style="width:100%;" mat-table [dataSource]="dataSource" matSortActive="id" matSort matSortDisableClear matSortDirection="desc">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
      <td class="center-cell" mat-cell *matCellDef="let row" [innerHTML]="row.id | highlight: dataSource.filter"></td>
    </ng-container>
    <ng-container matColumnDef="fileName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>FileName</th>
      <td class="center-cell" mat-cell *matCellDef="let row" [innerHTML]="row.fileName | highlight: dataSource.filter"></td>
    </ng-container>
    <ng-container matColumnDef="parameters">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Parameters</th>
      <td class="center-cell wrap-newlines" style="max-width:300px" mat-cell *matCellDef="let row" [innerHTML]="row.parameters | highlight: dataSource.filter | truncatelines:50:true" matTooltip="{{row.parameters}}"></td>
    </ng-container>
    <ng-container matColumnDef="processDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Process Date</th>
      <td class="center-cell" mat-cell *matCellDef="let row" [innerHTML]="row.processDate | highlight: dataSource.filter"></td>
    </ng-container>
    <ng-container matColumnDef="recordCount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Record Count</th>
      <td class="center-cell" mat-cell *matCellDef="let row" [innerHTML]="row.recordCount.toString() | highlight: dataSource.filter"></td>
    </ng-container>
    <ng-container matColumnDef="requestDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Request Date</th>
      <td class="center-cell" mat-cell *matCellDef="let row" [innerHTML]="row.requestDate | highlight: dataSource.filter"></td>
    </ng-container>
    <ng-container matColumnDef="processStatus">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td class="center-cell" mat-cell *matCellDef="let row" [innerHTML]="row.processStatus | highlight: dataSource.filter"></td>
    </ng-container>
    <ng-container matColumnDef="requestedUser">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>User</th>
      <td class="center-cell" mat-cell *matCellDef="let row" [innerHTML]="row.requestedUser | highlight: dataSource.filter"></td>
    </ng-container>
    <ng-container matColumnDef="downloadFile">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Download File</th>
      <td class="center-cell" mat-cell *matCellDef="let row">
        <button *ngIf="row.processStatus === 'Export Completed'" mat-raised-button color="primary" (click)="downloadExportFile(row.fileName)">Download</button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
    <tr class="tableRow" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <div class="tableNoInfoSection" *ngIf="dataSource.data.length === 0">
    <span *ngIf="!loadError">No records found</span>
    <span *ngIf="loadError">Error occurred during data load.</span>
  </div>
  <mat-paginator style="border: solid 1px #DCDCDC;" [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="25" showFirstLastButtons></mat-paginator>
</div>
